export default __webpack_public_path__ + "922cac3733f8a4384b1def43c2f09e0e.png";